import { makeAutoObservable, runInAction } from "mobx";
import store from "./store";
export default class JobPostStore {
  constructor() {
    makeAutoObservable(this);
  }

  isSaveJobPostingModalVisible = false;
  isDoneModalVisible = false;
  isSubmitting = false;
  loading = false;
  error = false;

  setIsSaveJobPostingModalVisible = (bool) => {
    runInAction(() => {
      this.isSaveJobPostingModalVisible = bool;
    });
  };

  setIsDoneModalVisible = (bool) => {
    runInAction(() => {
      this.isDoneModalVisible = bool;
    });
  };

  handleFinalSubmit = async (values, apiFunction, id = null) => {
    this.isSubmitting = true;
    try {
      const payload = {
        title: values.title,
        description: values.description,
        location: values.location,
        employmentType: values.employmentType,
        scheduleType: values.scheduleType,
        departmentId: values.departmentId,
        startDate: values.scheduleType === "Custom" && values.dateRange ? values.dateRange[0].format("YYYY-MM-DD") : null,
        endDate: values.scheduleType === "Custom" && values.dateRange ? values.dateRange[1].format("YYYY-MM-DD") : null,
        startTime: values.startTime ? values.startTime.format("h:mm A") : "",
        endTime: values.endTime ? values.endTime.format("h:mm A") : "",
        availableSlots: Number(values.availableSlots) || 0,
      };

      if (id) {
        await apiFunction.update(id, payload);
      } else {
        await apiFunction.create(payload);
      }

      runInAction(() => {
        this.isSaveJobPostingModalVisible = false;
        this.isDoneModalVisible = true;
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data || "Failed to save job posting";

      store.notificationStore.showNotification(errorMessage, "error", {
        title: "Error",
        duration: 5000,
      });
    } finally {
      runInAction(() => (this.isSubmitting = false));
    }
  };

  handleCloseJobPosting = async (id, apiFunction) => {
    this.loading = true;
    try {
      await apiFunction.closeJobOpening(id);
      store.notificationStore.showNotification("Job opening closed successfully", "success", {
        title: "Closed Application",
        duration: 5000,
      });
    } catch (error) {
      runInAction(() => {
        this.loading = false;
        this.error = true;
      });
      const errorMessage = error.response?.data?.message || error.response?.data || "An error occurred";

      store.notificationStore.showNotification(errorMessage, "error", {
        title: "Error",
        duration: 5000,
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };
}
